import { render } from "./submission.view.vue?vue&type=template&id=2921fac0&scoped=true&ts=true"
import script from "./submission.view.vue?vue&type=script&lang=ts"
export * from "./submission.view.vue?vue&type=script&lang=ts"

import "./submission.view.vue?vue&type=style&index=0&id=2921fac0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2921fac0"]])

export default __exports__